function Tutorial (){
    return(
        <div>
            Tutorijal
        </div>
    );
}

export default Tutorial;